// extracted by mini-css-extract-plugin
export default {"header-wrap-boxes":"HeaderBoxes_header-wrap-boxes__VXNme"};